var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAuthorText({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 28.8L33.9503 0V53.9999H58V28.8Z",
    fill: "#191814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0498 28.8L0.000116348 0V53.9999H24.0498V28.8Z",
    fill: "#191814"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iNTQiIHZpZXdCb3g9IjAgMCA1OCA1NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNNTggMjguOEwzMy45NTAzIDBWNTMuOTk5OUg1OFYyOC44WiIgZmlsbD0iIzE5MTgxNCIvPgogIDxwYXRoIGQ9Ik0yNC4wNDk4IDI4LjhMMC4wMDAxMTYzNDggMFY1My45OTk5SDI0LjA0OThWMjguOFoiIGZpbGw9IiMxOTE4MTQiLz4KPC9zdmc+Cg==";
export { SvgAuthorText as ReactComponent };